import Vue from 'vue'
import MobileDetect from 'mobile-detect'

function iOSversion() {
     if (/iP(hone|od|ad)/.test(navigator.platform)) {
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)]
    }
}

const md = new MobileDetect(window.navigator.userAgent)
let mob = false
let tablet = false
if (md.mobile() && md.phone()) {
    mob = true
    if (md.is('iPhone')) {
        document.body.style.height = '105vh'
    }
} else if (md.mobile() && md.tablet()) {
    tablet = true
}

window.mobile = mob
Vue.mixin({
    created: function () {
        this.$mobile = mob
        this.$tablet = tablet
    }
})



// WEBPACK FOOTER //
// ./src/mobile.js